import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Send, Loader2 } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Input } from '../ui/input';
import { Textarea } from '../ui/textarea';
import { Button } from '../ui/button';

const API = process.env.REACT_APP_BACKEND_URL;

export const ComposeDialog = ({ open, onOpenChange, initial, onSent }) => {
  const [form, setForm] = useState(initial);
  const [sending, setSending] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const send = async () => {
    if (!form.to?.trim() || !form.body?.trim()) return toast.error('Destinataire et message obligatoires');
    setSending(true);
    try {
      await axios.post(`${API}/api/gmail/send`, form);
      toast.success('E-mail envoyé');
      onOpenChange(false);
      onSent?.();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Échec de l'envoi");
    } finally {
      setSending(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl" data-testid="gmail-compose-dialog">
        <DialogHeader><DialogTitle>{form.thread_id ? 'Répondre' : 'Nouveau message'}</DialogTitle></DialogHeader>
        <div className="space-y-3">
          <Input placeholder="À (séparez par des virgules)" value={form.to} onChange={set('to')} data-testid="gmail-compose-to" />
          <Input placeholder="Cc" value={form.cc} onChange={set('cc')} data-testid="gmail-compose-cc" />
          <Input placeholder="Objet" value={form.subject} onChange={set('subject')} data-testid="gmail-compose-subject" />
          <Textarea rows={12} placeholder="Votre message…" value={form.body} onChange={set('body')} data-testid="gmail-compose-body" />
          <div className="flex justify-end">
            <Button onClick={send} disabled={sending} className="gap-2 bg-[#1B3170] hover:bg-[#13245a]" data-testid="gmail-compose-send">
              {sending ? <Loader2 className="h-4 w-4 animate-spin" /> : <Send className="h-4 w-4" />} Envoyer
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
